import { Manager_Contractor_Bool_Exp } from "@/generated/graphql";

const commonContractorRequestConditions: Manager_Contractor_Bool_Exp[] = [
  {
    approved: {
      _eq: false,
    },
  },
  {
    contractor: {
      deleted: {
        _eq: false,
      },
    },
  },
  {
    created_by: {
      
    }
  }
];

export default commonContractorRequestConditions;